import { render } from "./SubAccountInvestments.vue?vue&type=template&id=06cda544"
import script from "./SubAccountInvestments.vue?vue&type=script&lang=js"
export * from "./SubAccountInvestments.vue?vue&type=script&lang=js"
script.render = render

export default script